import React from 'react';

import { Banner } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const ExperienceBanner = ({ $isMobile }) => {
  return (
    <div className='min-w-[200px] tabletH:max-w-[344px] w-full flex flex-col items-start gap-4 tabletH:gap-2'>
      <Banner
        type='info'
        size='s'
        label='Please add language institutes to Activities.'
        labelKr='어학원은 활동 내역에 추가해 주세요.'
        hideButton
        hideClose={!$isMobile}
        className='px-3 py-2.5 tabletH:p-4'
        icon={<IdeaIcon />}
      />
      <Banner
        type='info'
        size='s'
        label={
          <>
            No full-time experience yet?
            <br />
            Part-time jobs in Korea also count — especially if they relate to
            your career.
          </>
        }
        labelKr={
          '아직 정규직 경력이 없으신가요?\n한국에서의 아르바이트 경력도 인정됩니다.\n특히 커리어와 관련된 경험이라면 꼭 추가해 주세요.'
        }
        hideButton
        hideClose={!$isMobile}
        className='px-3 py-2.5 tabletH:p-4'
        icon={<IdeaIcon />}
      />
    </div>
  );
};

export default ExperienceBanner;
